import React from "react";
import { useTheme } from "@/lib/theme";
import lockupDark from "@/assets/ph-lockup-dark.png"; // white lettering — for dark surfaces
import lockupLight from "@/assets/ph-lockup-light.png"; // dark lettering — for light surfaces

/**
 * Players Health lockup logo — the official gradient "y" mark + "PLAYERS / HEALTH"
 * two-line wordmark, exactly as supplied. Swaps lettering colour by theme so the
 * mark stays gradient while the wordmark reads correctly on light or dark.
 */
export default function Logo({ height = 40, className = "", style = {} }) {
  const { theme } = useTheme();
  const src = theme === "dark" ? lockupDark : lockupLight;
  return (
    <img
      src={src}
      alt="Players Health"
      className={className}
      style={{ display: "block", height, width: "auto", ...style }}
      data-testid="ph-logo"
    />
  );
}
